import axios from 'axios';
import { buildApiV2Url } from '../utils/apiUtils';
import { generateApiError } from '../utils/apiErrorMessages';
import { TEMPLATE_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';

export default (id, isFavorite) =>
  axios
    .patch(buildApiV2Url(`${TEMPLATE_TYPE_COLLECTION_PATH}/${id}`), {
      is_favorite: isFavorite,
    })
    .catch(generateApiError());
